import React, { FunctionComponent, useState } from 'react';

import Button from '../elements/Button';
import { sectionSharedDefaults, sectionSharedTypes } from '../../utils/SectionsProps';
import Modal from '../elements/Modal';
// import Input from '../elements/Input';

interface ctaProps extends sectionSharedTypes {
  split?: boolean;
  buttontext?: string;
  bannertext?: string;
  style?: any;
}

const Cta: FunctionComponent<ctaProps & typeof sectionSharedDefaults> = ({ buttontext }) => {
  const [modalActive, setModalActive] = useState(false);

  const openModal = (e: Event) => {
    e.preventDefault();
    setModalActive(true);
  };

  const closeModal = (e: Event) => {
    e.preventDefault();
    setModalActive(false);
  };

  return (
    <>
      <Button onClick={openModal} className="button button-primary button-wide-mobile">
        {buttontext}
      </Button>
      <Modal id="demo-modal" show={modalActive} handleClose={closeModal}>
        <div className="center-content">
          <h2 className="mt-0 mb-12">Get the App</h2>
          <p className="text-sm">
            Win cash prizes in our Weekly Prize Pool* while investing in a SIPC-insured brokerage.
            <a
              href="/opencash_weekly_prize_pool_official_rules_oct_2026_ma_exclusion.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="link-1 mt-1">
              see official rules
            </a>
          </p>

          <div className="mb-2">
            <a
              href={'https://apps.apple.com/us/app/opencash-long-term-investing/id1588293293'}
              rel={'noopener noreferrer'}
              className={'link-1'}
              target={'_blank'}>
              <img src="/images/app-store-badge.png" alt="iOS App" className={'ios-badge'} />
            </a>
          </div>
          <div>
            <a
              href={'https://play.google.com/store/apps/details?id=com.opencash'}
              rel={'noopener noreferrer'}
              className={'link-1'}
              target={'_blank'}>
              <img
                src="/images/google-play-badge.png"
                alt="Android App"
                className={'android-badge'}
              />
            </a>
          </div>
          {/*<Input placeholder={'Text me a download link'} />*/}
        </div>
      </Modal>
    </>
  );
};

export default Cta;
